import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTour } from '@reactour/tour';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import partialConstants from 'ui/partials/utils/constants';

import contactsConstants from '../../contact/utils/constants';
import c from '../utils/constants';

export default function useUpdateTask() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const { isOpen } = useTour();
  const args = state;

  return useMutation({
    //TODO: Type this properly
    mutationFn: async (payload: {
      id: string;
      values: Record<string, any>;
    }) => {
      if (isOpen) {
        return;
      }

      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v1/tasks/${payload.id}`,
            payload: payload.values,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/tasks/${payload.id}`,
            payload: payload.values,
          },
        }),
      );

      return data;
    },
    onSuccess: (successData) => {
      const { data } = successData ?? {};

      queryClient.invalidateQueries({ queryKey: [c.TASKS] });
      queryClient.invalidateQueries({ queryKey: [c.LOGS, data?.dealId] });
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.LEADS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      toastSuccess('Successfully updated task.');
    },
  });
}
